<div class="modal-header">
  <span class="fs-4">{{title}}</span>
</div>
<div class="modal-body">
  <p class="fs-6" [innerHTML]="body"></p>
</div>
<div class="modal-footer">
  <div class="d-flex">
    <button class="btn btn-outline-secondary ms-auto me-2" (click)="modal.close(false)">{{cancelButton}}</button>
    <button class="btn btn-outline-secondary ms-2" (click)="modal.close(true)">{{confirmButton}}</button>
  </div>
</div>
